import { DateTime } from 'luxon';
import { TableShiftPlanningListItem } from 'ogp/services/shift-service.types';
import { TableShiftPlanningColumnDefinition } from '../shift-planning-table.types';

export const getTableShiftPlanningData = (
  data: TableShiftPlanningListItem[]
): TableShiftPlanningColumnDefinition[] => {
  const result: TableShiftPlanningColumnDefinition[] = data.map((item) => {
    const dateTime = {
      fromDateTime: DateTime.fromISO(item.dateTime.fromDateTime),
      toDateTime: DateTime.fromISO(item.dateTime.toDateTime),
    };

    return {
      id: item.id,
      jobName: item.jobName,
      departmentName: item.departmentName,
      jobTypeName: item.jobTypeName,
      location: item.location,
      dateTime,
      state: item.state,
      action: item.id,
    };
  });
  return result;
};
